import { FC } from 'react';

import Flex from 'quarks/Flex';

import Form from 'components/Form';
import NextPodcast, { NextPodcastProps } from 'components/ResourceDetailLayout/components/Sidebar/NextPodcast';
import SocialShare, { SocialShareProps } from 'components/ResourceDetailLayout/components/Sidebar/SocialShare';
import SubscribeForm, { SubscribeFormProps } from 'components/ResourceDetailLayout/components/Sidebar/SubscribeForm';
import TableOfContents, {
  TableOfContentProps,
} from 'components/ResourceDetailLayout/components/Sidebar/TableOfContents';
import SidebarDemo from 'components/SidebarDemo';

import type { ContentfulComponentForm } from 'graphqlTypes';

type SidebarProps = {
  tocProps?: TableOfContentProps;
  socialShareProps?: SocialShareProps;
  subscribeFormProps?: SubscribeFormProps;
  nextPodcastProps?: NextPodcastProps;
  showGetDemo?: boolean;
  customForm?: ContentfulComponentForm;
};

const Sidebar: FC<SidebarProps> = ({
  showGetDemo,
  tocProps = {
    tableOfContents: [],
  },
  customForm,
  socialShareProps,
  subscribeFormProps,
  nextPodcastProps,
}) => {
  const showToc = tocProps?.tableOfContents?.filter(x => x?.content?.[0]?.isVisible).length > 0;
  const showNextPodcast = nextPodcastProps?.relatedPost;

  return (
    <Flex
      data-testid="sidebar"
      width="100%"
      maxWidth="100%"
      height="fit-content"
      flexDirection="column"
      position="relative"
      gap="32px"
      lg={{ position: 'sticky', top: '120px', maxWidth: '300px' }}
      className="sidebar"
    >
      {showToc && <TableOfContents {...tocProps} hasForm={!!subscribeFormProps} hasSocial={!!socialShareProps} />}
      {subscribeFormProps && <SubscribeForm {...subscribeFormProps} />}
      {customForm && <Form {...customForm} />}
      {showGetDemo && <SidebarDemo />}
      {showNextPodcast && <NextPodcast {...nextPodcastProps} />}
      {socialShareProps && <SocialShare {...socialShareProps} />}
    </Flex>
  );
};

export default Sidebar;

Sidebar.defaultProps = {
  tocProps: {
    tableOfContents: [],
  },
};
